module.exports = __webpack_public_path__ + "img/音乐部.22c9175f.jpg";